import { render, staticRenderFns } from "./ChatsActives.vue?vue&type=template&id=013088c2&scoped=true&"
import script from "./ChatsActives.vue?vue&type=script&lang=js&"
export * from "./ChatsActives.vue?vue&type=script&lang=js&"
import style0 from "./ChatsActives.vue?vue&type=style&index=0&id=013088c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013088c2",
  null
  
)

export default component.exports